import * as React from 'react';
import * as style from '../textReviews.module.scss';
import { styled } from '@mui/material';

const StyledButton = styled('button')({
  marginTop: '20px',
  textAlign: 'center',
  color: '#737373',
  fontWeight: '300',
  fontSize: '14px',
  lineHeight: '16px',
  background: '#fff',
  border: '1px solid #d8d8d8',
  borderRadius: '15px',
  padding: '10px 20px',
  '&:focus': {
    border: '1px solid #d8d8d8',
  },
});

export const TextReviewCard = ({ data }) => {
  const [isFullText, setIsFullText] = React.useState(false);
  return (
    <div className={style.textReviewContainer}>
      <div className={style.student__info}>
        {
          data.avatar ?
            <img
              src={data.avatar}
              width="60"
              height="60"
              alt={""}
              className={style.student__img}
            />
            :
            null
        }
        <div className={style.student__wrapper}>
          <p className={style.student__name}>{data.author}</p>
          {
            data.extra ?
              <p className={style.student__extra}>{data.extra}</p>
              :
              null
          }
        </div>
      </div>
      <p className={style.studentReview}>
        {data.visibleText}
        {data.hiddenText &&
          (isFullText ? (
            <>
              {data.hiddenText}
              <br />
              <StyledButton
                onClick={() => {
                  setIsFullText(false);
                }}
              >
                Свернуть
              </StyledButton>
            </>
          ) : (
            <>
              ...
              <br />
              <StyledButton
                onClick={() => {
                  setIsFullText(true);
                }}
              >
                Читать полностью
              </StyledButton>
            </>
          ))}
      </p>
    </div>
  );
};
